<template>
  <div>
    <template v-if="source.status == 0">
      <div class="treedetail tal clearfix " @click="selectFn(source)"
        :class="{ has: source.haf || source.select  , isDie: source.status == 0 }" v-if="source.showHide">
        <!-- <Tooltip class="tal ells1 fl" :style="{ 'padding-left': (this.num * 16) + 'px' }"
          style="width:25%;margin-left: -10px;" :content="source.fullPath" placement="right">
          <i class="cp f20 fl" style="padding:0 4px 0 10px;width: 30px;height: 26px;">
            <template v-if="source.children && source.children.length">
              <Icon type="md-arrow-dropright" @click.stop="btn(source)" v-if="!source.expend" />
              <Icon type="md-arrow-dropdown" @click.stop="btn(source)" v-else />
            </template>
          </i>
          <b>
            {{
                changeLow(source.fullPath)
            }}
          </b>
        </Tooltip> -->
        <!-- <Tooltip class="tal ells1 fl" style="width:5%;" :content="source.pid" placement="top-start">
        <b @click.stop="rowClick(source)" class="cp underLine">{{ source.pid }}</b>
      </Tooltip>
      <Tooltip class="tal ells1 fl"  :content="source.parentPid" placement="top-start">
      </Tooltip> -->
        <span class="tal ells1 fl " :style="{ 'padding-left': (this.num * 16) + 'px' }"
          style="width:48%;margin-left: -10px;" :title="changeLow(source.fullPath)">
          <i class="cp f20 fl  pr" :class="{'lineLeft':num!=0 && !(source.children && source.children.length)}" style="padding:0 4px 0 10px;width: 30px;height: 26px;">
            <template v-if="source.children && source.children.length">
              <Icon type="md-arrow-dropright" @click.stop="btn(source)" v-if="!source.expend" />
              <Icon type="md-arrow-dropdown" @click.stop="btn(source)" v-else />
            </template>
          </i>
          <b>

            <i :class="[source.status == 0 ?'pro1':'pro2']"></i>
            {{
                changeLow(source.fullPath)
            }}
          </b>
        </span>
        <span class="tal  fl" style="width:5%; text-indent: 10px;"> <b>{{
            source.pid
        }}</b></span>
        <span class="tal  fl" style="width:5%;text-indent: 10px;"> <b>{{
            source.parentPid
        }}</b></span>
        <span class="tal ells1 fl" style="width:18%;"
          v-if="source.fileProductName == '' || source.fileProductName == null">
          <b>{{
              source.fileProductName
          }}</b>
        </span>
        <span class="tal ells1 fl" style="width:18%;" :title="source.fileProductName" placement="top-start" v-else>
          <b>{{
              source.fileProductName
          }}</b>
        </span>
        <!-- <span class="tal ells1 fl" style="width:10%;"
          v-if="source.fileDescription == '' || source.fileDescription == null">
          <b>{{
              source.fileDescription
          }}</b>
        </span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.fileDescription" placement="top-start">
          <b>{{
              source.fileDescription
          }}</b>
        </span> -->
        <!-- <span v-if="source.fileVersion == '' || source.fileVersion == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.fileVersion
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%; text-indent: 10px;" :title="source.fileVersion" placement="top-start">
          <b>{{
              source.fileVersion
          }}</b>
        </span>
        <span v-if="source.signName == '' || source.signName == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.signName
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.signName" placement="top-start">
          <b>{{
              source.signName
          }}</b>
        </span> -->
        <span v-if="source.createTime == '' || source.createTime == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.createTime
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.createTime" placement="top-start">
          <b>{{
              source.createTime
          }}</b>
        </span>
        <span v-if="source.endTime == '' || source.endTime == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.endTime
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.endTime" placement="top-start">
          <b>{{
              source.endTime
          }}</b>
        </span>
        <span class="tar  fr"><Button type="primary" ghost size="small"
            @click.stop="rowClick(source)">详情</Button></span>
      </div>
    </template>
    <template v-else>
      <div class="treedetail tal clearfix " @click="selectFn(source)"
        :class="{ has: source.haf || source.select, isDie: source.status == 0 }">
        <span class="tal ells1 fl " :style="{ 'padding-left': (this.num * 16) + 'px' }"
          style="width:48%;margin-left: -10px;" :title="changeLow(source.fullPath)">
          <i class="cp f20 fl  pr" :class="{'lineLeft':num!=0 && !(source.children && source.children.length),'lineLeft2':num ==source.children.length -1} "  style="padding:0 4px 0 10px;width: 30px;height: 26px;">
            <template v-if="source.children && source.children.length">
              <Icon type="md-arrow-dropright" @click.stop="btn(source)" v-if="!source.expend" />
              <Icon type="md-arrow-dropdown" @click.stop="btn(source)" v-else />
            </template>
          </i>
          <b>
            <i :class="[source.status == 0 ?'pro1':'pro2']"></i>
           {{
                changeLow(source.fullPath)
            }}
          </b>
        </span>
        <span class="tal  fl" style="width:5%;text-indent: 10px;"> <b>{{
            source.pid
        }}</b></span>
        <span class="tal  fl" style="width:5%;text-indent: 10px;"> <b>{{
            source.parentPid
        }}</b></span>
        <span class="tal ells1 fl" style="width:18%;"
          v-if="source.fileProductName == '' || source.fileProductName == null">
          <b>{{
              source.fileProductName
          }}</b>
        </span>
        <span class="tal ells1 fl" style="width:18%;" :title="source.fileProductName" placement="top-start" v-else>
          <b>{{
              source.fileProductName
          }}</b>
        </span>
        <!-- <span class="tal ells1 fl" style="width:10%;"
          v-if="source.fileDescription == '' || source.fileDescription == null">
          <b>{{
              source.fileDescription
          }}</b>
        </span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.fileDescription" placement="top-start">
          <b>{{
              source.fileDescription
          }}</b>
        </span>
        <span v-if="source.fileVersion == '' || source.fileVersion == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.fileVersion
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.fileVersion" placement="top-start">
          <b>{{
              source.fileVersion
          }}</b>
        </span>
        <span v-if="source.signName == '' || source.signName == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.signName
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.signName" placement="top-start">
          <b>{{
              source.signName
          }}</b>
        </span> -->
        <span v-if="source.createTime == '' || source.createTime == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.createTime
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.createTime" placement="top-start">
          <b>{{
              source.createTime
          }}</b>
        </span>
        <span v-if="source.endTime == '' || source.endTime == null" class="tal ells1 fl" style="width:10%;">
          <b>{{
              source.endTime
          }}</b></span>
        <span v-else class="tal ells1 fl" style="width:10%;" :title="source.endTime" placement="top-start">
          <b>{{
              source.endTime
          }}</b>
        </span>
        <span class="tar  fr"><Button type="primary" ghost size="small"
            @click.stop="rowClick(source)">详情</Button></span>
        <!-- <span class="item fl signName ells1">{{ source.signName }}</span>
      <span class="item fl ells1 pid tac">{{ source.pid }}</span>
      <span class="item fl ells1 parentPid tac">{{ source.parentPid }}</span>
      <span class="item fl ells1 createTime tac">{{ source.createTime }}</span>
      <span class="item fl detail tac">
        <Button size="small" type="info" @click.stop="rowClick(source)">详情</Button>
      </span> -->
      </div>
    </template>
    <div v-if="source.expend">
      <treedetail v-for="(item, index) in list" :key="index" :source="item" :list='item.children' :num='num + 1'>
      </treedetail>
    </div>
    <div class="detailConList pf pr noSelect" v-if="isShowDetail">
      <div class="detailCon pa center">
        <h3 class="title tal f14 fw">进程详情<i class="closeIncon f30 pa cp" @click="isShowDetail = false">×</i></h3>
        <div class="inDetailCon">
          <div class="itemCon clearfix">
            <div class="fl">进程属性</div>
            <div class="fl">信息</div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程名</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.exeName)">{{ detailInfo.exeName }}<Icon  v-if="detailInfo.exeName!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程ID</div>
            <div class="fl "  @click="handleCopy( detailInfo.pid)">{{ detailInfo.pid }}<Icon  v-if="detailInfo.pid!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">创建时间</div>
            <div class="fl ells1">{{ detailInfo.createTime }}</div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">结束时间</div>
            <div class="fl ells1">{{ curData.endTime }}</div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程状态</div>
            <div class="fl ells1" v-text="curData.status == 1 ? '运行中' : '已结束'"></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程路径</div>
            <div class="fl ells1"  @click="handleCopy( detailInfo.fullPath)" :title="detailInfo.fullPath">{{ detailInfo.fullPath }}<Icon  v-if="detailInfo.fullPath!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程命令行</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.cmdLine)">{{ detailInfo.cmdLine }}<Icon v-if="detailInfo.cmdLine!=''&& detailInfo.cmdLine!=' '" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">文件说明</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.fileDescription)">{{ detailInfo.fileDescription }}<Icon v-if="detailInfo.fileDescription!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">文件版本</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.fileVersion)">{{ detailInfo.fileVersion }}<Icon v-if="detailInfo.fileVersion!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">公司名称</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.fileProductName)">{{ detailInfo.fileProductName }}<Icon v-if="detailInfo.fileProductName!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程MD5</div>
            <div class="fl ells1"  @click="handleCopy( detailInfo.md5)">{{ detailInfo.md5 }}<Icon v-if="detailInfo.md5!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">进程特征码</div>
            <div class="fl ells1" @click="handleCopy( detailInfo.hash)">{{ detailInfo.hash }}<Icon v-if="detailInfo.hash!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">数字签名公司名
            </div>
            <div class="fl ells1" @click="handleCopy( detailInfo.signName)">{{ detailInfo.signName }}<Icon v-if="detailInfo.signName!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
          <div class="itemCon clearfix">
            <div class="fl">数字签名序列号
            </div>
            <div class="fl ells1" @click="handleCopy( detailInfo.signCode)">{{ detailInfo.signCode }}<Icon v-if="detailInfo.signCode!=''" class="f16 cp mainCol fw" type="ios-copy-outline"/></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProDetail } from '@/requests/proTree.js'
import { Base64 } from 'js-base64'
export default {
  name: 'treedetail',
  props: {
    clientId: {
      type: String,
    },
    source: {
      type: Object,
      default: ''
    },
    list: { type: Array },
    num: {
      type: Number,
      default: 0
    },
    isShowHide: {
      type: Boolean,
      default: false
    },
    osStartTime: ''
  },
  data () {
    return {
      flag: false,
      isShowDetail: false,
      detailInfo: '',
      isSelect: false,
      curData: ''
    }
  },
  watch: {
    '$store.state.log.selectPro' () {
      let index = this.$store.state.log.selectPro.findIndex((val) => val.pid == this.source.pid)
      if (index == -1) {
        this.isSelect = false
      } else {
        this.isSelect = true
      }
    }
  },
  methods: {
    handleCopy(val) {
      if (val == '' || val == null) { return }
      let that = this
      this.$copyText(val).then(
        function (e) {
          return that.$Message.success('复制成功' + val)
        },
        function (e) {
          //   alert('复制失败')
        }
      )
    },
    selectFn (val) {
      val.select = !val.select

      if (val.select) {
        this.$store.dispatch(
          'log/actionAddSelectPro',
          val
        )
      } else {
        this.$store.dispatch(
          'log/actionDelSelectPro',
          val
        )
      }
    },
    rowClick (val) {
      this.curData = val
      this.getProDetail(val)
    },
    async getProDetail (val) {
      let object = eval('(' + this.$route.query.curData + ')')
      let res = await getProDetail({
        id: val.id,
        osStartTime: object.osStartTime,
        clientId: window.localStorage.getItem('clientId')
      })
      if (res.code == 200) {
        res.data.cmdLine = Base64.decode(res.data.cmdLine)
        this.detailInfo = res.data
        this.isShowDetail = true
      }
    },
    btn (val) {
      val.expend = !val.expend
      // this.flag = !this.flag
    },
    changeLow (val) {
      if (val[1] == ':') {
        let characters = [...val]
        characters[0] = characters[0].toUpperCase()
        val = characters.join('')
      }
      return val
    }
  },
  computed: {
    indent () {
      return `paddingLeft: (${this.num * 20}px)`
    }
  }

}
</script>
<style lang="scss">
.treedetail {
  .tal.ivu-tooltip {
    .ivu-tooltip-rel {
      width: calc(100%) !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 16px;
      box-sizing: border-box;
    }
  }

  .fl {
    box-sizing: border-box;
  }

  font-size: 12px;
}
</style>
<style lang="scss" scoped>
.underLine {
  text-decoration: underline;
}

.treedetail {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  .tal,
  .tar {
    line-height: 24px;
    height: 24px;
    font-family: emoji;
    b {
      line-height: 24px;
      font-family: emoji;
    }
  }
  &:hover{
    background: #ffef96a4 !important;
  }
  &.has {
    background: #ffe100;
    box-sizing: content-box;
    &:hover{
      background: #ffd901a4;
    }
  }

  &.isDie {
    b {
      color: rgb(145, 145, 145);

    }
  }

  &:hover {
    background: #f0faff;
  }

  .item {
    box-sizing: border-box;
    // border: 1px solid #e8eaec;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    border-top: 0;
    text-indent: 2px;

    .f16 {
      padding-left: 4px;
    }
  }

  .fullPath {
    width: 680px;

  }

  b {
    font-weight: normal;
  }

  .signName {
    width: 248px;
    border-left: 0;
    padding: 0 5px;
  }

  .pid {
    border-left: 0;
    width: 72px;
  }

  .parentPid {
    border-left: 0;
    width: 72px;
  }

  .createTime {
    border-left: 0;
    width: 144px;
  }

  .detail {
    border-left: 0;
    width: 84px;
  }
}

.detailCon {
  background: #fff;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: .5);
  width: 60%;
  z-index: 999;
  border-radius: 4px;
  top: 40%;
  min-width: 600px;
  max-width: 1000px;

  .title {
    line-height: 40px;
    text-indent: 20px;
    border-bottom: 1px solid #e8eaec;

    .closeIncon {
      right: 20px;
    }
  }

  .inDetailCon {
    padding: 20px;

    .itemCon {
      .fl {
        width: 120px;
        border: 1px solid #e8eaec;
        line-height: 24px;
        height: 24px;

        &:nth-child(2n) {
          width: calc(100% - 120px);
          margin-left: -1px;
        }
      }

      &:nth-child(2n) {
        .fl {
          border-top: 0;
        }
      }
    }
  }

}

.detailConList {
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: .5);
  width: 100%;
  height: 100%;
  z-index: 999;
}
.lineLeft{
  &::before{
    content: '';
    width: 1px;
    height: 26px;
    top: 50%;
    left: 18px;
    border-left: 1px dashed #c3c3c3 ;
    position: absolute;
    margin-top: -13px;
  }
  &::after{
    content: '';
    width: 8px;
    height: 1px;
    top: 14px;
    left: 19px;
    border-top: 1px dashed #c3c3c3  ;
    position: absolute;
  }
}
.pro1,.pro2{
  width: 15px;
  height: 15px;
  display: inline-block;
  background: url('../../../assets/img/icon/pro1.png') no-repeat center;
  background-size: cover;
  vertical-align: middle;
  margin-right: 2px;
}
.pro2{
  background-image: url('../../../assets/img/icon/pro2.png');
}
</style>